if (!customElements.get('cart-gift-wrap')) {
  customElements.define(
    'cart-gift-wrap',
    class CartGiftWrap extends HTMLElement {
      constructor() {
        super();

        const giftWrapToggle = document.querySelector('#gift-wrap');

        giftWrapToggle.addEventListener('input', function (event) {
          let formData = new FormData();
          formData.append('attributes[Gift wrap]', this.checked ? 'Yes' : 'No');

          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            body: formData,
          });
        });
      }
    }
  );
}
